export class CloudPrincipalAws {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "iamArn",
            "baseName": "iamArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudPrincipalAws.attributeTypeMap;
    }
    constructor() {
    }
}
